(() => {
  'use strict';

  const DESKTOP_QUERY = '(min-width: 990px)';
  const HIDE_DISTANCE = 14;
  const REVEAL_DISTANCE = 8;

  const desktopMedia = window.matchMedia(DESKTOP_QUERY);

  let lastScrollY = Math.max(window.scrollY, 0);
  let accumulatedDelta = 0;
  let ticking = false;

  const getHeaderElements = () => {
    const headerSection = document.querySelector(
      '.shopify-section.header-section'
    );

    if (!headerSection) {
      return {};
    }

    return {
      headerSection,
      headerWrapper: headerSection.querySelector(
        '.header-section--wrapper'
      ),
      desktopHeader: headerSection.querySelector('.site-header')
    };
  };

  const showHeader = () => {
    const { headerSection } = getHeaderElements();

    if (headerSection) {
      headerSection.classList.remove('psi-smart-header-hidden');
    }
  };

  const resetHeader = () => {
    accumulatedDelta = 0;
    lastScrollY = Math.max(window.scrollY, 0);
    showHeader();
  };

  const headerIsInUse = (headerSection, desktopHeader) => {
    const activeElement = document.activeElement;

    return (
      (activeElement && desktopHeader.contains(activeElement)) ||
      Boolean(
        desktopHeader.querySelector(
          '.nav-hover, .force-open, .force-hover, [aria-expanded="true"]'
        )
      ) ||
      document.body.classList.contains('js-drawer-open') ||
      document.body.classList.contains('fullscreen-popup-open')
    );
  };

  const updateHeader = () => {
    ticking = false;

    const currentScrollY = Math.max(window.scrollY, 0);
    const scrollDelta = currentScrollY - lastScrollY;
    lastScrollY = currentScrollY;

    const {
      headerSection,
      headerWrapper,
      desktopHeader
    } = getHeaderElements();

    if (!headerSection || !headerWrapper || !desktopHeader) {
      accumulatedDelta = 0;
      return;
    }

    const smartStickyEnabled =
      headerWrapper.dataset.psiSmartSticky === 'true';

    if (!desktopMedia.matches || !smartStickyEnabled) {
      accumulatedDelta = 0;
      showHeader();
      return;
    }

    if (
      !headerSection.classList.contains('sticky-header') ||
      !headerSection.classList.contains('sticked')
    ) {
      accumulatedDelta = 0;
      showHeader();
      return;
    }

    if (headerIsInUse(headerSection, desktopHeader)) {
      accumulatedDelta = 0;
      showHeader();
      return;
    }

    if (Math.abs(scrollDelta) < 1) {
      return;
    }

    if (
      (scrollDelta > 0 && accumulatedDelta < 0) ||
      (scrollDelta < 0 && accumulatedDelta > 0)
    ) {
      accumulatedDelta = 0;
    }

    accumulatedDelta += scrollDelta;

    if (accumulatedDelta >= HIDE_DISTANCE) {
      headerSection.classList.add('psi-smart-header-hidden');
      accumulatedDelta = 0;
    } else if (accumulatedDelta <= -REVEAL_DISTANCE) {
      showHeader();
      accumulatedDelta = 0;
    }
  };

  const onScroll = () => {
    if (ticking) return;

    ticking = true;
    window.requestAnimationFrame(updateHeader);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('pageshow', resetHeader);

  document.addEventListener('headerUnstuck', resetHeader);

  document.addEventListener('headerSticked', () => {
    accumulatedDelta = 0;
    lastScrollY = Math.max(window.scrollY, 0);
  });

  document.addEventListener('focusin', (event) => {
    if (event.target.closest('.shopify-section.header-section')) {
      showHeader();
    }
  });

  document.addEventListener('pointerdown', (event) => {
    if (event.target.closest('.shopify-section.header-section')) {
      showHeader();
    }
  });

  /* Shopify Theme Editor reloads sections dynamically */
  document.addEventListener('shopify:section:load', resetHeader);

  const onMediaChange = () => resetHeader();

  if (desktopMedia.addEventListener) {
    desktopMedia.addEventListener('change', onMediaChange);
  } else {
    desktopMedia.addListener(onMediaChange);
  }
})();